var searchSuggester = {
	inputPlaceholder: "Zoeken",
	clearSearchTerm: "Wis zoekterm",
	noResults: "Geen resultaten gevonden",
	allSearchResults: "Alle zoekresultaten",
	validationErrors: {
		searchTerm: {
			invalidInput: "Ongeldige invoer"
		}
	}
};
var searchSuggesterTranslationsNl = {
	searchSuggester: searchSuggester
};

export { searchSuggesterTranslationsNl as default, searchSuggester };
